var _path, _circle, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.46 16.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill",
    d: "m9.32,1c.63,0,1.15.51,1.15,1.15v12.49c0,.63-.51,1.15-1.15,1.15H2.15c-.63,0-1.15-.51-1.15-1.15V2.15c0-.63.51-1.15,1.15-1.15h7.17m0-1H2.15C.96,0,0,.96,0,2.15v12.49c0,1.18.96,2.15,2.15,2.15h7.17c1.18,0,2.15-.96,2.15-2.15V2.15c0-1.18-.96-2.15-2.15-2.15h0Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "fill",
    cx: 5.73,
    cy: 13.07,
    r: 1.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fill",
    d: "m2.19,4.4c-.13,0-.26-.05-.35-.15-.2-.2-.2-.51,0-.71l1.41-1.41c.2-.2.51-.2.71,0s.2.51,0,.71l-1.41,1.41c-.1.1-.23.15-.35.15Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "fill",
    d: "m2.19,6.95c-.13,0-.26-.05-.35-.15-.2-.2-.2-.51,0-.71L5.86,2.07c.2-.2.51-.2.71,0s.2.51,0,.71L2.54,6.8c-.1.1-.23.15-.35.15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.8daf910afe888b7790081a74ca9d78d1.svg";
export { ForwardRef as ReactComponent };